import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64bcb8ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progressplan-container" }
const _hoisted_2 = { class: "progress-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "left-container" }
const _hoisted_5 = { class: "right-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.progressList, (li, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "progress",
          key: index,
          onClick: ($event: any) => (_ctx.progressDetail(li))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString(li.name), 1),
            _createElementVNode("div", null, " 计划开始：" + _toDisplayString(li.startPlan === "" ? "-" : li.startPlan.substr(0, 10)), 1),
            _createElementVNode("div", null, " 计划完成：" + _toDisplayString(li.endPlan === "" ? "-" : li.endPlan.substr(0, 10)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                style: _normalizeStyle({
                color:
                  li.approveStatus === 0
                    ? '#FEA235'
                    : li.approveStatus === 1
                    ? '#C820E0'
                    : li.approveStatus === 2
                    ? '#8893A3'
                    : '#E02020',
              })
              }, _toDisplayString(_ctx.approveStatusFilter(li.approveStatus)), 5)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                style: _normalizeStyle({ color: _ctx.endRealFilter(li) })
              }, null, 4)
            ])
          ])
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}